module.exports = {"xs":0,"sm":544,"md":768,"lg":992,"xl":1200}


//////////////////
// WEBPACK FOOTER
// ./src/data/json/breakpoints.json
// module id = 718
// module chunks = 35783957827783